import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const apiUrlSectores = `${process.env.REACT_APP_API_URL}/section`;
const apiUrlAddresses = `${process.env.REACT_APP_API_URL}/addres`;

const CreateSection = () => {
    const [sector, setSector] = useState('');
    const [sede, setSede] = useState('');
    const [sedes, setSedes] = useState([]);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSedes = async () => {
            try {
                const { data } = await axios.get(apiUrlAddresses);
                setSedes(data);
            } catch (e) {
                console.error('Error cargando sedes', e);
            }
        };
        fetchSedes();
    }, []);

    const store = async (e) => {
        e.preventDefault();
        setError('');

        if (!sector.trim()) {
            setError('El nombre del sector es obligatorio');
            return;
        }
        if (!sede) {
            setError('Debe seleccionar una sede');
            return;
        }

        setIsSubmitting(true);
        try {
            await axios.post(apiUrlSectores, { sector: sector.trim(), id_sede: Number(sede) });
            alert('✅ Sector creado exitosamente');
            navigate('/admin/AbmSectores');
        } catch (error) {
            console.error('Error al guardar el sector:', error);
            if (error.response?.status === 400) {
                setError(error.response.data.error || 'Ya existe un sector con ese nombre');
            } else {
                setError('Error al crear el sector. Intente nuevamente.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        navigate('/admin/AbmSectores');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-100 py-8 px-4">
            <div className="max-w-3xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-t-2xl shadow-xl p-6 border-b-4 border-green-500">
                    <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-4 rounded-xl shadow-lg">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800">Nuevo Sector</h1>
                            <p className="text-gray-600 mt-1">Crea un nuevo departamento o área de trabajo</p>
                        </div>
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={store} className="bg-white rounded-b-2xl shadow-xl p-8">
                    {error && (
                        <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg">
                            <div className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-red-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                </svg>
                                <div>
                                    <p className="text-sm font-semibold text-red-900">Error</p>
                                    <p className="text-sm text-red-700 mt-1">{error}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="space-y-6">
                        {/* Sede */}
                        <div>
                            <label htmlFor="sede" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-blue-600">📍</span>
                                Sede
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                id="sede"
                                value={sede}
                                onChange={(e) => setSede(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all outline-none text-gray-800"
                            >
                                <option value="" disabled>Seleccione una sede...</option>
                                {sedes.map(s => (
                                    <option key={s.id_direccion} value={s.id_direccion}>
                                        {s.nombre_sede || `${s.direccion} - ${s.localidad}`}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Nombre del Sector */}
                        <div>
                            <label htmlFor="sector" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-green-600">🏢</span>
                                Nombre del Sector
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                id="sector"
                                placeholder="Ej: Recursos Humanos, Finanzas, Producción"
                                value={sector}
                                onChange={(e) => setSector(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t-2 border-gray-200">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-green-700 hover:to-emerald-700 transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        >
                            {isSubmitting ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    Guardando...
                                </span>
                            ) : (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Crear Sector
                                </span>
                            )}
                        </button>

                        <button
                            type="button"
                            onClick={handleCancel}
                            disabled={isSubmitting}
                            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg shadow-md transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <span className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Cancelar
                            </span>
                        </button>
                    </div>
                </form>

                {/* Info adicional */}
                <div className="mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-green-900">Información importante</p>
                            <p className="text-sm text-green-700 mt-1">
                                Los sectores se utilizan para organizar usuarios y pedidos dentro de una sede específica.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateSection;


